<template lang="pug">
  .pagination-wrapper
    .pagination-data(v-if="showPaginationData")
      span {{ firstRecord }}-{{ lastRecord }}
      span /{{ pagination.total }}
    slot
</template>

<script>
  import { every, values } from 'lodash'

  export default {
    props: {
      pagination: {
        type: Object,
        default() {
          return {
            total: undefined,
            per_page: undefined,
            current_page: undefined,
            last_page: undefined
          }
        }
      }
    },

    computed: {
      showPaginationData() {
        return every(values(this.pagination), item => item != undefined)
      },

      lastRecord() {
        const maxCount = this.pagination.current_page * this.pagination.per_page
        return Math.min(maxCount, this.pagination.total)
      },

      firstRecord() {
        return ((this.pagination.current_page - 1) * this.pagination.per_page + 1)
      }
    }
  }
</script>

<style lang="scss">
  .pagination-wrapper {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 20px 0;

    .pagination-button {
      border: 1px solid #e7ecf4;
      cursor: pointer;
      margin: 5px;

      &.active {
        border: 1px solid #3da6eb;
        font-weight: 700;
      }
    }

    .pagination-data {
      border: 1px solid #ececec;
      border-radius: 5px;
      color: #888;
      font-size: 0.9em;
      font-weight: 500;
      margin-right: 6px;
      padding: 5px 8px;
    }
  }
</style>